// extracted by mini-css-extract-plugin
module.exports = {"recos":"cy-z","productCardOverride":"dy-z"};